import { Grid } from "@mui/material";
import { useMemo } from "react";
import ContentTitle from "../../../../components/Content/ContentTitle";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import { useAuthContext } from "../../../../contexts/AuthContext";
import { INavigationLink } from "../../../../interfaces/INavigation";
import { useEnvironmentContext } from "../../../../contexts/EnvironmentContext";
import Iframe from "../../../../components/Iframe";
import Empty from "../../../../components/Empty";


const ManagementDashboard = (linkProps: INavigationLink) => {
    const { translate } = useLanguageContext();
    const { environment } = useEnvironmentContext();
    const { user, enterprise } = useAuthContext();


    const managementDashboardUrl = useMemo(() => {
        if (user && user.allowAllEnterprisesViewedInManagementDashboard) {
            const managementDashboardUrl = environment.managementDashboardUrl;

            if (managementDashboardUrl && managementDashboardUrl.trim().length > 0) {
                return managementDashboardUrl;
            }
        }

        return enterprise?.managementDashboardUrl?.trim() ?? '';
    }, [user, environment, enterprise]);


    return (
        <>
            {
                managementDashboardUrl && managementDashboardUrl.length > 0 ? <>
                    <Iframe src={managementDashboardUrl} title={translate(linkProps.name)} className="position-absolute" />
                </> : <>
                    <Grid item xs={12} className='grid-header'>
                        <Grid item className='grid-title'>
                            <ContentTitle 
                                name={translate(linkProps.name)} 
                                description={enterprise?.name}
                                applyTranslation={false}
                            />
                        </Grid>
                    </Grid>

                    <Grid container className='grid-content'>
                        <Grid item xs={12} className='paper-content display-flex alignitems-center justifycontent-center'>
                            <Empty text='noUrlConfiguredForPowerBiVisualization' />
                        </Grid>
                    </Grid>
                </>
            }
        </>
    );
}

export default ManagementDashboard;